import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { InstitutionErrorResolutionService } from '../../shared-services/services/institution-error-resolution.service';
import { SnackBarService } from '../../shared-services/services/snack-bar.service';

@Component({
    selector: 'app-fiserv-webhook-error-resolution',
    templateUrl: './fiserv-webhook.component.html',
    styleUrls: ['./fiserv-webhook.component.scss'],
    standalone: false
})
export class FiservWebhookErrorResolutionComponent implements OnInit {

  public flId: string;
  public enrollmentId: string;
  public action: string;
  public fdaWebHookCall$: Observable<any>;
  public showButton = false;

  constructor(private errorResolutionService: InstitutionErrorResolutionService) { }

  ngOnInit(): void {
    this.callFdaWebhookApi();
  }

  public callFdaWebhookApi() {
    parent.postMessage({
        code: 'hide-widget'
    }, '*');
    if (window.location.href.includes('action=cancel')) {
        parent.postMessage({
            code: 'cancel-fiserv-widget'
        }, '*');
    } else {
        const pathSegments = window.location.href.split('/');

        this.flId = pathSegments[pathSegments.length - 3];
        this.enrollmentId = pathSegments[pathSegments.length - 2];
        this.action = pathSegments[pathSegments.length - 1];
        this.fdaWebHookCall$ = this.errorResolutionService.callFdaWebhookErrorResolutionApi(this.flId,
                                        this.enrollmentId, this.action);

        this.fdaWebHookCall$.subscribe();
    }
  }
}
